import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 'normal',
    color: 'grey.600',
    textDecoration: 'underline',
    _focus: {
      boxShadow: 'none',
    },
  },
  sizes: {
    'body-xl': {
      fontSize: '2xl',
      lineHeight: '2rem',
      letterSpacing: 'widest',
    },
    'body-lg': {
      fontSize: 'lg',
      lineHeight: '1.5rem',
      letterSpacing: 'extraWide',
    },
    'body-md': {
      fontSize: 'md',
      lineHeight: '1.5rem',
      letterSpacing: 'superWide',
    },
    'body-sm': {
      fontSize: 'sm',
      lineHeight: '1rem',
      letterSpacing: 'ultraWide',
    },
    'body-xs': {
      fontSize: 'xs',
      lineHeight: '1rem',
    },
  },
  variants: {
    semibold: {
      fontWeight: 'semibold',
    },
    noDecoration: {
      textDecoration: 'none',
      _hover: {
        textDecoration: 'none',
      },
    },
  },
  defaultProps: {
    size: 'body-md',
  },
};
